module.exports = __webpack_public_path__ + "img/invoice-example.097bc32b.png";